///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Dynamically append the Zendesk JS snippet to the body
//
///////////////////////////////////////////////////////////////////////////////////////////////////
/*
var key = '3bfdf816-f089-40f3-8d82-861603ba9ccf';
var script = document.createElement("script");

script.src = "https://static.zdassets.com/ekr/snippet.js?key=" + key;
script.id = "ze-snippet";
script.addEventListener('load', function() {
    setTimeout(function() {
        abcsetup.zendesk.init();
    }, 50);
});

document.getElementsByTagName("body")[0].appendChild(script);
*/



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.zendesk = abcsetup.zendesk || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    if (abcsetup.guest) {
        window.zESettings = {
            webWidget: {
                offset: { vertical: '40px' }
            }
        };
    }

    if ($('#ze-snippet').length > 0) {
        abcsetup.zendesk.init();
    }
});



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.zendesk = {
    init: function () {
        if (!abcsetup.guest) {
            zE('webWidget', 'prefill', {
                name: {
                    value: abcsetup.user.name1 + ' ' + abcsetup.user.name2,
                    //readOnly: true
                },
                email: {
                    value: abcsetup.user.email,
                    //readOnly: true
                }
            });
        }
    },
}
